export default "__VITE_ASSET__ByMp$tx9__"